import { render, staticRenderFns } from "./DfHiddenField.vue?vue&type=template&id=4510646b&"
import script from "./DfHiddenField.vue?vue&type=script&lang=js&"
export * from "./DfHiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4510646b')) {
      api.createRecord('4510646b', component.options)
    } else {
      api.reload('4510646b', component.options)
    }
    module.hot.accept("./DfHiddenField.vue?vue&type=template&id=4510646b&", function () {
      api.rerender('4510646b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfHiddenField.vue"
export default component.exports